module.exports = __webpack_public_path__ + "img/grin-hearts.65cc11ca.svg";